import { jsx as _jsx } from "react/jsx-runtime";
import { ConfirmationModal, Typography } from 'seagull';
import { getTestIds } from 'seagull/utils/TestIds';
import { useLocaleKeys } from '~/i18n';
export const { DefaultToSUpdateNoticeTID } = getTestIds();
export const DefaultToSUpdateNotice = (param)=>{
    let { onDismiss, onViewUpdatedTerms } = param;
    const { t: announcementModalTexts } = useLocaleKeys('components.legalTermsDropdown.announcementModal');
    return /*#__PURE__*/ _jsx(ConfirmationModal, {
        bi: {
            primaryButton: {
                name: 'default_tos_announcement_view_updated'
            },
            secondaryButton: {
                name: 'default_tos_announcement_dismiss'
            }
        },
        title: announcementModalTexts.title(),
        width: "620px",
        testId: DefaultToSUpdateNoticeTID.Root(),
        textAlignCenter: false,
        content: /*#__PURE__*/ _jsx(Typography, {
            children: announcementModalTexts.body()
        }),
        primaryButtonLabel: announcementModalTexts.viewUpdatedTermsCta(),
        secondaryButtonLabel: announcementModalTexts.dismissCta(),
        onPrimaryButtonClick: onViewUpdatedTerms,
        onSecondaryButtonClick: onDismiss
    });
};
